import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  /**
   * Contains in-progress loading requests
   */
  public static loadingSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private static loadingMap: Map<string, boolean> = new Map<string, boolean>();
  private static expiryDate: Date | null = null;
  private static loadingDisabled: boolean = false;
  private static interval: any;

  static init() {
    if (LoadingService.interval)
      clearInterval(LoadingService.interval);
    LoadingService.interval = setInterval(() => { LoadingService.checkClearLoading() }, 1000);
  }

  private static checkClearLoading() {
    let now = new Date();
    if (this.expiryDate && now > this.expiryDate) {
      this.closeAllLoaders();
    }
  }

  static disableLoading() {
    this.loadingDisabled = true;
    this.closeAllLoaders();
  }

  static enableLoading() {
    this.loadingDisabled = false;
    this.closeAllLoaders();
  }

  private static closeAllLoaders() {
    this.loadingMap.clear();
  }

  /**
   * Sets the loadingSub property value based on the following:
   * - If loading is true, add the provided url to the loadingMap with a true value, set loadingSub value to true
   * - If loading is false, remove the loadingMap entry and only when the map is empty will we set loadingSub to false
   * This pattern ensures if there are multiple requests awaiting completion, we don't set loading to false before
   * other requests have completed. At the moment, this function is only called from the @link{HttpRequestInterceptor}
   * @param loading {boolean}
   * @param url {string}
   */
  static setLoading(loading: boolean, url: string): void {
    if (loading) {
      if (this.loadingDisabled) {
        return;
      }
      this.loadingMap.set(url, loading);
      this.loadingSub.next(true);
      // Set the expiry date to 30 seconds from now
      this.expiryDate = new Date();
      this.expiryDate.setTime(this.expiryDate.getTime() + 30 * 1000); // Add 30 seconds
    } else {
      if (this.loadingMap.has(url)) {
        this.loadingMap.delete(url);
      }
      if (this.loadingMap.size <= 0) {
        this.expiryDate = null;
      }
      if (this.loadingMap.size === 0) {
        this.loadingSub.next(false);
      }
    }
  }
}